var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421 136.235v-3.948c-4.13-3.692-13.692-9.811-14.544-10.434-.187-5.035-.713-10.524-2.18-11.853h-1.551c-1.468 1.33-1.995 6.818-2.18 11.853-.853.623-10.414 6.742-14.545 10.434v3.948l14.78-4.998c.239 2.505.594 4.804.954 7.24-.328.184-1.46 1.4-4.799 4.333V145l6.565-2.19 6.563 2.19v-2.19c-3.337-2.933-4.47-4.149-4.797-4.333.36-2.436.715-4.735.953-7.24L421 136.235",
    transform: "translate(-627 -252) translate(241 142) rotate(90 403.5 127.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.svg";
export { ForwardRef as ReactComponent };